export default __webpack_public_path__ + "static/media/Warlord's Blade.683170cc.jpg";